import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import { StockType } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import { StockInputValue_Edit_NoOption_Intl } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/types.ts';
import { $, html } from 'rune-ts';
import klass from './Input_Stock.module.scss';
import common_klass from '../../section-views/styles/common.module.scss';
import { Base_Input_Stock } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Base_Input_Stock.ts';
import { stockDataUtil } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/util.ts';
import { VolumeInputType } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/views/StockVolumeModal/StockVolumeModal.ts';
import { ChangeSkuVolume } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/events.ts';
import { Tooltip } from '@services/MarppleShop/renderApp/components/atoms/Tooltip/Tooltip.ts';
import { shareFont } from '@services/MarppleShop/shared/typography';

interface InputStock_EditNoOption_Intl extends InputEditor {
  mode: typeof MODE.EDIT_TPL_INTL;
  stock_type: typeof StockType.TOTAL_STOCK;
  value: StockInputValue_Edit_NoOption_Intl[];
  readonly?: boolean;
  is_studio_worker_admin?: boolean;
}

export class Input_Stock_EditNoOption_Intl extends Base_Input_Stock<InputStock_EditNoOption_Intl> {
  protected override inputTemplate() {
    return html`
      <div class="${klass.stock_table} ${klass.edit_no_option_intl}">
        <div class="${klass.row} ${klass.header}">
          <div class="${klass.col}">재고</div>
          <div class="${klass.col}">
            재고 관리 번호
            ${new Tooltip({
              id: this.data.name,
              content: html`
                <div class="${common_klass.tooltip_content_container} ${shareFont('14_medium')}">
                  <div class="${common_klass.tooltip_content_divider}">
                    <span>·</span>
                    <span>재고관리번호를 입력하지 않은 경우 자동생성됩니다.</span>
                  </div>
                  <div class="${common_klass.tooltip_content_divider}">
                    <span>·</span>
                    <span
                      >입고 상품을 등록한 후엔 옵션, 재고관리번호, 상품 카테고리는 수정할 수 없습니다.</span
                    >
                  </div>
                </div>
              `,
              size: 'x_small',
              variant: 'studio',
            })}
          </div>
          <div class="${klass.col}">체적 정보</div>
        </div>
        ${this.data.value.map((item, index) => {
          return html`
            <div class="${klass.row}">
              <div class="${klass.col}">
                ${stockDataUtil.numberInput({
                  index,
                  name: this.data.name,
                  value: item.stock,
                  readonly: !this.data.is_studio_worker_admin,
                  onFocusout: (view) => {
                    this.onNumericOptionChange(view, 'stock');
                  },
                })}
              </div>
              <div class="${klass.col}">
                ${stockDataUtil.textInput({
                  index,
                  readonly: this.data.readonly,
                  name: this.data.name,
                  value: item.sku || String(item.id || ''),
                  placeholder: 'SKU',
                  onFocusout: (view) => {
                    this.onStringOptionChange(view, 'sku');
                  },
                })}
              </div>
              <div class="${klass.col}">
                ${stockDataUtil.volumeButton({
                  index,
                  name: '',
                  value: item.volume,
                  // sku가 존재하고 어드민 권한이 없으면 수정 X
                  readonly: this.data.readonly && !this.data.is_studio_worker_admin,
                  onRegister: (view) => {
                    this.onVolumeOptionChange(view);
                  },
                })}
              </div>
            </div>
          `;
        })}
      </div>
    `;
  }

  public override setError(is_error?: boolean) {
    $(`.${klass.stock_table}`)
      .findAll(`[data-is_registered]`)
      .forEach(($element) => {
        const button = $element.element();
        const isRegistered = button.dataset.is_registered === String(true);
        if (!isRegistered && is_error) button.setAttribute('data-color', 'red');
        else {
          if (button.textContent?.trim() === '등록') button.setAttribute('data-color', 'line_sky');
          else button.setAttribute('data-color', 'line_gray');
        }
      });
  }

  protected onVolumeOptionChange(view: VolumeInputType) {
    this.data.value = this.data.value.map((item, idx) =>
      idx === view.getIndex() ? { ...item, volume: view.getState() } : item,
    );

    this.dispatchEvent(ChangeSkuVolume, {
      bubbles: true,
      detail: {
        stock_values: this.getValue(),
      },
    });
  }
}
